import { ILayout } from "@interfaces";
import { selectApp } from "@redux";
import { Layout, Spin } from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { device } from "@utils";

export const AuthLayout = (props: ILayout) => {
  const { loading } = useSelector(selectApp);

  return (
    <StyledWrapper>
      <StyledAuth>
        <Spin spinning={loading}>{props.children}</Spin>
      </StyledAuth>
    </StyledWrapper>
  );
};
const StyledWrapper = styled(Layout)`
  background-image: url("./psi-health-care.png");
`;
const StyledAuth = styled.section`
  background-color: #fff;
  min-width: 600px;
  min-height: 300px;
  margin: auto;
  margin-top: 20vh;
  @media ${device.tablet} {
    min-width: 100%;
    min-height: 240px;
    padding: 16px;
    background-color: transparent;
  }
`;
